import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
// import PaymentUnpaidTable from './components/PaymentUnpaidTable';

const PaymentUnPaid = () => {
  return <ErrorBoundary>{/* <PaymentUnpaidTable /> */}</ErrorBoundary>;
};

export default PaymentUnPaid;
